import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Service } from '../models/service.model';
import { GLOBAL } from './global';
import { VariableService } from '../services/sharedVariables';

@Injectable()
export class ServiceService{
   public url: string;
   public user_id:number;

   constructor(
     public _http: Http,
     public VariableService: VariableService
   )
   {
     this.url = GLOBAL.url;
     this.user_id = parseInt(this.VariableService.getCookie('user_id'));
   }

   getServices()
   {
     return this._http.get(this.url+'services/'+this.user_id).map(res => res.json());
   }

   getService()
   {
     return "getCservice from service";
   }

   addService(service: Service)
   {
     let json = JSON.stringify(service);
     let params = 'json='+json;
     console.log(params);
     let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
     return this._http.post(this.url+'add-service/'+this.user_id,params, {headers:headers}).map(res => res.json());

   }

   updateService(id:number,pService: Service)
   {
     let json = JSON.stringify(pService);
     let params = "json="+json;
     let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
     console.log(params);
     return this._http.post(this.url+'edit-service/'+id+'/'+this.user_id,params,{headers: headers})
                       .map(res => res.json());
   }

   deleteService(id:number)
   {
     return this._http.get(this.url+'delete-service/'+id+'/'+this.user_id)
                     .map(res => res.json());
   }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/services/service.service.ts